/**
 * KLIPY app key (TRE-2104). Publishable — KLIPY requires the requests to come straight from the
 * user's browser — so it lives in the public Vite env. Empty key = the GIF button is hidden.
 */
export const KLIPY_APP_KEY: string = import.meta.env.VITE_KLIPY_APP_KEY || "";
